import _extends from 'babel-runtime/helpers/extends';

import { systemMessageUnreadCountAPI } from '@/api/common';
// import { crmCheckVersionAPI } from '@/api/admin/update'

import SystemMessage from './SystemMessage';
import NavManager from './NavManager';

import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import { on, off } from '@/utils/dom';

export default {
  components: {
    SystemMessage: SystemMessage,
    NavManager: NavManager
  },
  props: {
    navIndex: {
      type: [Number, String],
      default: 0
      // authRedirect: ''
    }
  },
  data: function data() {
    return {
      unreadNums: {
        allCount: 0,
        announceCount: 0,
        crmCount: 0,
        examineCount: 0,
        eventCount: 0,
        logCount: 0,
        taskCount: 0
      },
      mesOnlyAnnouncement: false,
      sysMessageShow: false,
      intervalId: null,
      type: 0,
      items: [],
      showItems: [],
      hiddenItems: [],
      navManagerShow: false,
      isNewest: false
    };
  },

  computed: _extends({}, mapGetters(['userInfo', 'lang', 'logo', 'crm', 'bi', 'manage', 'oa', 'project', 'navActiveIndex', 'collapse', 'headerModule']), {
    moreMenu: function moreMenu() {
      return [{
        command: 'baseInfo',
        divided: false,
        label: '基本信息',
        icon: 'wk wk-user'
      }, {
        command: 'help',
        divided: true,
        label: '帮助中心',
        icon: 'wk wk-help'
      }, {
        command: 'logOut',
        divided: false,
        label: '退出登录',
        icon: 'wk wk-logout'
      }, {
        command: 'version',
        divided: false,
        label: '\u7248\u672C ' + WKConfig.version,
        icon: 'wk wk-version',
        disabled: true
      }];
    },
    allItemsObj: function allItemsObj() {
      var tempsItems = {};
      if (this.crm) {
        tempsItems.crm = {
          title: '客户管理',
          type: 1,
          module: 'crm',
          path: '/crm',
          icon: 'wk wk-customer',
          fontSize: '17px'
        };
      }

      if (this.oa && this.oa.taskExamine) {
        tempsItems.taskExamine = {
          title: '任务/审批',
          type: 4,
          module: 'taskExamine',
          path: '/taskExamine',
          icon: 'wk wk-office',
          fontSize: '16px'
        };
      }

      if (this.oa && this.oa.log) {
        tempsItems.log = {
          title: '日志',
          type: 3,
          module: 'log',
          path: '/workLog',
          icon: 'wk wk-log',
          fontSize: '17px'
        };
      }

      if (this.oa && this.oa.book && this.oa.book.index) {
        tempsItems.book = {
          title: '通讯录',
          type: 6,
          module: 'book',
          path: '/addressBook',
          icon: 'wk wk-address-book',
          fontSize: '17px'
        };
      }

      if (this.project) {
        tempsItems.project = {
          title: '项目管理',
          type: 2,
          module: 'project',
          path: '/project',
          icon: 'wk wk-project',
          fontSize: '15px'
        };
      }

      if (this.bi) {
        tempsItems.bi = {
          title: '商业智能',
          type: 5,
          path: '/bi',
          module: 'bi',
          icon: 'wk wk-business-intelligence',
          fontSize: '18px'
        };
      }

      if (this.oa && this.oa.calendar) {
        tempsItems.calendar = {
          title: '日历',
          type: 8,
          module: 'calendar',
          path: '/calendar/index',
          icon: 'wk wk-calendar',
          fontSize: '20px'
        };
      }

      return tempsItems;
    }
  }),
  watch: {
    navManagerShow: function navManagerShow(val) {
      if (val == false) {
        this.changeNavIndex();
      }
    }
  },
  created: function created() {
    this.getHeaderModule();
    // const _this = this
    // async function decorator() {
    //   var { data } = await crmCheckVersionAPI()
    //   _this.isNewest = _this.checkIsNewest(data.version, data.serverVersion)
    // }
    // decorator()
  },
  mounted: function mounted() {
    var _this = this;

    on(document, 'click', this.handleDocumentClick);

    window.onresize = function () {
      _this.changeMenu(document.documentElement.clientWidth);
    };

    // 消息数
    this.getSystemUnreadNum('visible');

    this.$bus.on('document-visibility', function (state) {
      _this.getSystemUnreadNum(state);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.off('document-visibility');
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    off(document, 'click', this.handleDocumentClick);
  },

  methods: {
    /**
     * 获取置顶头
     */
    getHeaderModule: function getHeaderModule() {
      var _this2 = this;

      if (!this.headerModule) {
        this.$store.dispatch('WKHeaderModule').then(function (res) {
          _this2.getTopHeaderModule();
        }).catch(function () {
          // this.getTopHeaderModule()
        });
      } else {
        this.getTopHeaderModule();
      }
    },


    /**
     * 根据关键词获取菜单数据
     */
    getTopHeaderModule: function getTopHeaderModule() {
      if (this.headerModule.length) {
        var allList = [];
        for (var index = 0; index < this.headerModule.length; index++) {
          var key = this.headerModule[index];
          var menu = this.allItemsObj[key];
          if (menu && allList.length < 8) {
            allList.push(menu);
          }
        }
        this.items = allList;
      } else {
        var _allList = [];
        for (var _key in this.allItemsObj) {
          if (_allList.length < 8) {
            _allList.push(this.allItemsObj[_key]);
          }
        }
        this.items = _allList;
      }
      this.changeMenu(document.documentElement.clientWidth);
    },
    changeMenu: function changeMenu(clintWidth) {
      var showItems = [];
      var hiddenItems = [];
      for (var index = 0; index < this.items.length; index++) {
        var element = this.items[index];
        if (clintWidth - 450 - (index + 1) * 130 > 0) {
          showItems.push(element);
        } else {
          hiddenItems.push(element);
        }
      }
      this.showItems = showItems;
      this.hiddenItems = hiddenItems;

      this.changeNavIndex();
    },
    changeNavIndex: function changeNavIndex() {
      var isHidden = true;
      for (var index = 0; index < this.showItems.length; index++) {
        var element = this.showItems[index];
        if (this.navIndex == element.path) {
          isHidden = false;
        }
      }

      var navActiveIndex = isHidden ? 'other' : this.navIndex;
      if (this.navActiveIndex != navActiveIndex) {
        this.$store.commit('SET_NAVACTIVEINDEX', navActiveIndex);
      }
    },
    navItemsClick: function navItemsClick(path) {
      if (path != 'other') {
        this.navManagerShow = false;
        this.$router.push(path);
      } else {
        this.navManagerShow = !this.navManagerShow;
      }
      this.$store.commit('SET_NAVACTIVEINDEX', path);
      this.$emit('nav-items-click', path);
    },
    enterSystemSet: function enterSystemSet() {
      this.$router.push({
        name: 'manage'
      });
    },


    /**
     * 获取系统未读消息数
     */
    getSystemUnreadNum: function getSystemUnreadNum(state) {
      var _this3 = this;

      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      if (state == 'visible') {
        this.sendSystemUnreadNum();
        this.intervalId = setInterval(function () {
          _this3.sendSystemUnreadNum();
        }, 600000);
      }
    },
    sendSystemUnreadNum: function sendSystemUnreadNum() {
      var _this4 = this;

      systemMessageUnreadCountAPI().then(function (res) {
        _this4.unreadNums = res.data;
      }).catch(function () {
        if (_this4.intervalId) {
          clearInterval(_this4.intervalId);
          _this4.intervalId = null;
        }
      });
    },


    /**
     * 有客户权限点击logo 进入仪表盘
     */
    enterCustoemBoard: function enterCustoemBoard() {
      if (this.crm) {
        this.$router.push('/crm/workbench');
      }
    },
    moreMenuClick: function moreMenuClick(command) {
      var _this5 = this;

      if (command == 'baseInfo') {
        this.$router.push({
          name: 'person'
        });
      } else if (command == 'help') {
        window.open('https://www.72crm.com/help');
      } else if (command == 'logOut') {
        this.$confirm('退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var loading = Loading.service({
            target: document.getElementById('#app')
          });
          _this5.$store.dispatch('LogOut').then(function () {
            location.reload();
            loading.close();
          }).catch(function () {
            location.reload();
            loading.close();
          });
        }).catch(function () {});
      }
    },


    /**
     * 控制导航管理隐藏
     */
    handleDocumentClick: function handleDocumentClick(e) {
      if (!this.$refs.navManagerMenu || !this.$refs.navManager || this.$refs.navManagerMenu.$el.contains(e.target) || this.$refs.navManager.$el.contains(e.target)) return;

      this.navManagerShow = false;
    },
    navManagerSelect: function navManagerSelect(_ref) {
      var path = _ref.path,
          module = _ref.module;

      this.navManagerShow = false;
      this.$router.push(path);

      var navActiveIndex = path;
      if (!this.headerModule.includes(module)) {
        navActiveIndex = 'other';
      }
      this.$store.commit('SET_NAVACTIVEINDEX', navActiveIndex);
    },
    updateClick: function updateClick() {
      this.$router.push('/manage/update');
    },
    checkIsNewest: function checkIsNewest(a, b) {
      var a = toNum(a);
      var b = toNum(b);

      if (a > b) {
        return false;
      } else {
        return true;
      }

      function toNum(a) {
        var a = a.toString();
        var c = a.split('.');
        var num_place = ['', '0', '00', '000', '0000'];
        var r = num_place.reverse();
        for (var i = 0; i < c.length; i++) {
          var len = c[i].length;
          c[i] = r[len] + c[i];
        }
        var res = c.join('');
        return res;
      }
    },


    /**
     * 查看消息详情
     */
    checkMessageDetail: function checkMessageDetail(onlyAnnouncement) {
      this.mesOnlyAnnouncement = onlyAnnouncement;
      this.sysMessageShow = true;
    }
  }
};